var exports = {
  "iE": "x31de4314--2aedda--wrapper",
  "kL": "x31de4314--2aedda--container",
  "yR": "x31de4314--2aedda--seo-block",
  "DD": "x31de4314--2aedda--title",
  "nf": "x31de4314--2aedda--link",
};

module.exports = exports;
